import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { categoryAPI, collectionAPI, productAPI } from '../services/api';

const normalizeImageUrl = (url) => {
  if (!url) return '';
  const value = String(url).trim();
  if (!value) return '';

  const safeValue = value
    .replace(/\.heic(?=[?#]|$)/gi, '.jpg')
    .replace(/\.heif(?=[?#]|$)/gi, '.jpg');

  if (safeValue.includes('cloudinary.com') && !/[?&]fm=jpg/i.test(safeValue)) {
    return `${safeValue}${safeValue.includes('?') ? '&' : '?'}fm=jpg`;
  }

  return safeValue;
};

export default function Shop() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedCategory = searchParams.get('category') || '';
  const selectedCollection = searchParams.get('collection') || '';
  const [categories, setCategories] = useState([]);
  const [collections, setCollections] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    categoryAPI.getAllCategories().then((response) => setCategories(response.data.categories || []));
    collectionAPI.getAllCollections().then((response) => setCollections(response.data.collections || []));
  }, []);

  useEffect(() => {
    setLoading(true);
    productAPI.getAllProducts({
      category: selectedCategory || undefined,
      collection: selectedCollection || undefined,
      limit: 40
    })
      .then((response) => setProducts(response.data.products || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [selectedCategory, selectedCollection]);

  const updateQuery = (params) => {
    const nextParams = new URLSearchParams(searchParams);
    Object.entries(params).forEach(([key, value]) => {
      if (!value) {
        nextParams.delete(key);
      } else {
        nextParams.set(key, value);
      }
    });
    setSearchParams(nextParams);
  };

  const selectedName = categories.find((category) => category._id === selectedCategory)?.name || '';
  const selectedCollectionName = collections.find((collection) => collection._id === selectedCollection)?.name || '';
  const childCategories = categories.filter((category) => category.parentCategory);

  return <div className="shop-page">
    <div className="shop-header"><div><span className="eyebrow">Browse the collection</span><h1>{selectedName || selectedCollectionName || 'Shop all products'}</h1></div><div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
      <select value={selectedCategory} onChange={(event) => updateQuery({ category: event.target.value, collection: selectedCollection })}><option value="">All categories</option>{childCategories.map((category) => <option key={category._id} value={category._id}>{category.name}</option>)}</select>
      <select value={selectedCollection} onChange={(event) => updateQuery({ collection: event.target.value, category: selectedCategory })}><option value="">All collections</option>{collections.map((collection) => <option key={collection._id} value={collection._id}>{collection.name}</option>)}</select>
    </div></div>
    <div className="category-chips"><button className={!selectedCategory && !selectedCollection ? 'active' : ''} onClick={() => updateQuery({ category: '', collection: '' })}>All</button>{childCategories.map((category) => <button className={selectedCategory === category._id ? 'active' : ''} key={category._id} onClick={() => updateQuery({ category: category._id, collection: selectedCollection })}>{category.name}</button>)}{collections.map((collection) => <button className={selectedCollection === collection._id ? 'active' : ''} key={collection._id} onClick={() => updateQuery({ collection: collection._id, category: selectedCategory })}>{collection.name}</button>)}</div>
    {loading ? <div className="page-loading">Loading products...</div> : <div className="product-grid">{products.length ? products.map((product) => <article className="product-card" key={product._id} onClick={() => navigate(`/product/${product._id}`)}><div className="product-image-wrap"><img className="product-image" src={normalizeImageUrl(product.images?.find((image) => image.isPrimary)?.url || product.images?.[0]?.url)} alt={product.name} /></div><div className="product-body"><h3>{product.name}</h3><span className="price">₹{Number(product.price || 0).toLocaleString('en-IN')}</span></div></article>) : <div className="empty-state">No info available for this selection.</div>}</div>}
  </div>;
}
